import { render, staticRenderFns } from "./ShipperSandbox.vue?vue&type=template&id=108fa885&scoped=true"
import script from "./ShipperSandbox.vue?vue&type=script&lang=js"
export * from "./ShipperSandbox.vue?vue&type=script&lang=js"
import style0 from "./ShipperSandbox.vue?vue&type=style&index=0&id=108fa885&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "108fa885",
  null
  
)

export default component.exports